import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { WithChildrenProps } from "../components";
import { logoutAction, useAuthentication } from "../reducer/authentication";
import { loadingAction } from "../reducer/loading";
import AuthService from "../service/AuthService";

export default function Authenticated({ children }: WithChildrenProps) {

    var timer: number = 0;

    const dispatch = useDispatch();

    const { loggedIn, user } = useAuthentication();

    useEffect(() => {
        if (user) {
            startTimer();
            validateToken();
        }
        return stopTimer;
    }, []);

    async function logOut() {
        dispatch(loadingAction(true));
        await AuthService.instance.logout();
        dispatch(loadingAction(false));
        dispatch(logoutAction());
    }

    async function validateToken() {
        var user = await AuthService.instance.getAuthUser();
        if (user === null) {
            await logOut();
        }
    }

    function startTimer() {
        timer = window.setInterval(validateToken, 60 * 1000); //1 minute
    }

    function stopTimer() {
        window.clearInterval(timer);
    }

    if (loggedIn && user) return <>{children}</>;

    return null;
}